import React, { createContext } from 'react';

interface Context {
    locale: string;
    recaptchaSiteKey: string;
}

interface AuthConfigContextProps {
    children: React.ReactNode;
    value: Context;
}

const AuthConfigContext = createContext<Context>({
    locale: '',
    recaptchaSiteKey: '',
});

export function formatLocale(locale: string) {
    const [lang, region] = locale.split(/[-_]/);

    return [lang, region.toUpperCase()].join('-');
}

export function AuthConfigContextProvider({ children, value }: AuthConfigContextProps) {
    const val = {
        ...value,
        locale: formatLocale(value.locale),
    };

    return <AuthConfigContext.Provider value={val}>{children}</AuthConfigContext.Provider>;
}

export function useAuthConfigContext() {
    const context = React.useContext(AuthConfigContext);
    if (context === undefined) {
        throw new Error('useAuthConfigContext must be used within a AuthConfigContextProvider');
    }
    return context;
}
